import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../../../api/http";
import userapiservice from "../../../../api/userapiservice";
import Loader from "../../../../components/Loader/Loader";
import ToastComponent from "../../../../components/ToastCompoent/ToastComponent";
import CardList from "../CardList/CardList";
import "./ourPurpose.scss";
import { useSelector } from "react-redux";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

export default function OurPurpose({ activeKey }) {
    const localData = useSelector((state) => state?.localStorage)
    const { micrositeID, tabConfigId } = localData
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [videoUrl, setVideoUrl] = useState("");
    const [mediaType, setMediaType] = useState("");
    const id = micrositeID;

    const getAboutData = async (activeKey, id) => {
        try {
            setLoading(true);
            if (id) {
                const response = await getRequest(
                    userapiservice.getAboutUsDetailsTabs(id, activeKey, tabConfigId),{},false
                );
                setResponseData(response || []);

                setLoading(false);
            }
        } catch (error) {
            toast.error(<ToastComponent type={'Error'} message={error?.error || 'Sorry, Something went wrong'} />)
            setLoading(false);
        }
    };


    const PlayVideoHandler = (url, mediaType) => {
        setMediaType(mediaType)
        setVideoUrl(url);
        setIsModalOpen(true);
    };

    const convertToStandardURL = (shortUrl) => {
        if (shortUrl?.indexOf('youtu.be') !== -1) {
            const video_id = shortUrl?.split('youtu.be/')[1].split('?')[0];
            return `https://www.youtube.com/watch?v=${video_id}`;
        }
        return shortUrl;
    }

    const handleCancel = () => {
        setIsModalOpen(false);
        setVideoUrl("");
    };

    const onCardClickHandler = (data) => {
        navigate(`/microsite/${data.id}/micrositeDetails`, {
            state: { page: activeKey, data: data },
        });
    };

    useEffect(() => {
        if (activeKey && id) {
            getAboutData(activeKey, id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (
            <Loader />
        )
    } else {
        return (
            <CardList
            sort={false}
                responseData={responseData}
                color={color}
                PlayVideoHandler={PlayVideoHandler}
                convertToStandardURL={convertToStandardURL}
                isModalOpen={isModalOpen}
                handleCancel={handleCancel}
                videoUrl={videoUrl}
                mediaType={mediaType}
                onCardClickHandler={onCardClickHandler}
            />
        );
    }
}
